<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="Line Card" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="content-list-abstract">
          <h2>Genuine Mall(HK) Electronics Limited – one of the world’s largest industrial electronic component suppliers.</h2>
          <h2>We can help you with your local product and design requirements and as a division of a global powerhouse, we can navigate the global supply chain.</h2>
          <h2>Whether your technology focus is Communications, RF & Wireless, Solid State Lighting, Display Technologies, or general applications; we have the leading edge product technologies, technical specialists, and world-class logistics to help you accelerate your time to market. C & I Semiconductors – Better Service, Better Support!</h2>
        </div>
        <div class="zyf">
          <img src="../assets/img/1.png" alt="Supplier Image" />
        </div>
        <div class="supplier-list">
          <div v-for="(letterGroup, index) in supplierGroups" :key="index" class="supplier-column">
            <ul>
              <li>{{ letterGroup.letter }}</li>
              <li v-for="supplier in letterGroup.suppliers" :key="supplier">{{ supplier }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      supplierGroups: [
        { letter: 'A', suppliers: [ 'AB Interconnect/TTE', 'Abracon', 'Adam Technologies', 'Alliance Memory', 'Ampire', 'Analog Devices', 'Angstrohm/Vishay', 'Approved Memory', 'APX Technologies', 'Atmel', 'Avago Technologies', 'Aveslink', 'Avx'] },
        { letter: 'B', suppliers: ['BC Components/Vishay', 'BI Technologies/TTE', 'BOURNS'] },
        { letter: 'C', suppliers: [ 'Carclo Optics', 'Cardinal Components', 'Cermetek', 'Chi Mei', 'Citizen Systems America', 'Cooliance', 'Cornell Dubilier/CDE', 'COSEL USA', 'CREE'] },
        { letter: 'D', suppliers: [ 'Dale/Vishay', 'Digital View', 'DRI Relays'] },
        { letter: 'E', suppliers: [ 'ECS, Inc.', 'EDT', 'E-ink/PVI/Hydis', 'Epson Semiconductor', 'ERG', 'Excelsys Technologies'] },
        { letter: 'F', suppliers: [ 'Fairchild', 'FEMA', 'Foil Resistors/Vishay', 'Fox Electronics', 'Fusion Optix', 'FREESCALE'] },
        { letter: 'G', suppliers: [ 'GainSpan', 'GigOptix', 'Greenliant'] },
        { letter: 'H', suppliers: [ 'Hitachi', 'Honeywell', 'Hititte Microwave'] },
        { letter: 'I', suppliers: [ 'Idea, Inc.', 'IOXUS', 'IR/Vishay', 'IRC/TTE', 'IR Touch'] },
        { letter: 'J', suppliers: [ 'Jaro Caps', 'Jaro Thermal', 'JST'] },
        { letter: 'K', suppliers: ['Kemet', 'Kingbright', 'Kordis'] },
        { letter: 'L', suppliers: [ 'Lapis Semiconductor/OKI', 'LATTICE', 'LSI/CSI'] },
        { letter: 'M', suppliers: [ 'Marvell', 'Mean Well', 'Mitsubishi Electric', 'Mitsumi', 'Monolithic Power', 'MOTOROLA', 'MURATA', 'Systesm/MPS'] },
        { letter: 'N', suppliers: [ 'Nakagawa Manufacturing', 'NDK', 'NEC TOKIN America', 'Nemco', 'Newhaven', 'NJR', 'NXP'] },
        { letter: 'O', suppliers: ['One Touch', 'Opnext', 'OPTEK/TTE', 'Opto/Vishay', 'Osram', 'Omron'] },
        { letter: 'P', suppliers: [ 'Polymer Optics', 'ProTek Devices', 'PLX'] },
        { letter: 'R', suppliers: ['RECOM Power', 'Richtek', 'Roederstein/Vishay', 'ROHM Semiconductor'] },
        { letter: 'S', suppliers: [ 'Samsung', 'Semelab/TTE', 'SEMICOA', 'Sfernice/Vishay', 'Siliconix/Vishay', 'Spectrol/Vishay', 'Sprague/Vishay', 'State of the Art'] },
        { letter: 'T', suppliers: ['Taiwan Semi', 'Tamura', 'Tansitor/Vishay', 'TDK', 'Texas Instruments', 'Thin Film/Vishay', 'TOCOS', 'Tokin America', 'Touch International', 'TT Electronics'] },
        { letter: 'V', suppliers: [ 'VaOpto', 'Vishay', 'Vishay Precision Group/VPG', 'Vitesse', 'Vitramon/Vishay'] },
        { letter: 'W', suppliers: [ 'Wilbrecht', 'Winbond', 'Wintec Industries', 'World Products LLC', 'WP Wireless'] },
        { letter: 'X', suppliers: [ 'Xicor'] },
      ]
    };
  },
  mounted() {
    this.loading = false; // Simulate loading completion
  }
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 90%; /* Make it responsive */
      max-width: 1240px; /* Set a max width */
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;
      padding: 20px; /* Add padding */

      .content-list-abstract {
        text-align: center;
        font-size: 18px; /* Adjust font size */
        line-height: 1.5;
        margin: 40px 0;
        
        h2 {
          margin: 20px 0;
          font-weight: normal; /* Make h2 font weight normal */
        }
      }
    }
  }
}

.zyf {
  display: flex; /* Center the image */
  justify-content: center;
  img {
    width: 100%; /* Make the image responsive */
    max-width: 1000px; /* Set a max width */
  }
}

.supplier-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .supplier-column {
    width: calc(25% - 20px); /* Adjust the column width */
    margin: 10px;
    list-style-type: none;

    ul {
      padding: 0;
      margin: 0;
      text-align: center;

      li {
        font-size: 16px; /* Adjust font size */
        margin: 5px 0; /* Add spacing between items */
      }
    }
  }
}
</style>
